import i18next from 'i18next';

i18next.addResources('es', 'PremiumFeatureGate', {
  title: 'Funcionalidad exclusiva del Plan Premium',
  description:
    'Tu plan actual no incluye acceso a esta funcionalidad. Mejora tu suscripción para desbloquear todas las herramientas avanzadas.',
  seePlans: 'Ver planes disponibles',
  goBack: 'Quizás más tarde'
});
